export const applicationEndpoints = {
  users: 'users',
  all: 'users/all',
  usersToImpersonate: 'users/to-impersonate',
  impersonateUser: 'oauth2/impersonate/:userId',
  retrieveTranslations: 'lokalise/retrieveTranslationFiles',
  getRoleByCode: 'roles/get-by-code',
  contractsAvenantSearch: 'contracts/avenant-search',
  contractsDrafts: 'contracts/drafts',
  contracts: 'contracts',
  referentielsCompanies: 'referentiels/companies',
  referentielsBranches: 'referentiels/branches',
  referentielsSites: 'referentiels/sites',
  referentielsOrganizationalEntities: 'referentiels/organizational-entities',
  referentielsBusinessDomains: 'referentiels/business-domains',
  referentielsCandidateOrigins: 'referentiels/candidate-origins',
  referentielsFixedTermReasons: 'referentiels/fixed-term-reasons',
  referentielsPositionLevels: 'referentiels/position-levels',
  hr4uPeople: 'hr4u/people',
  ssnDecode: 'ssn/decode',
  contractTemplates: 'contract-templates',
  referentielsCompanyGroups: 'referentiels/company-groups',
  referentielsPositions: 'referentiels/positions',
  referentielsNationalities: 'referentiels/nationalities',
  referentielsCountries: 'referentiels/countries',
  referentielsCcnipPositions: 'referentiels/ccnip-positions',
  contractsReview: 'contracts/review',
  contractsDocument: 'contracts/:contractId/document',
  contractsSaveDocument: 'contracts/:contractId/document',
  contractsRegenerateReview: 'contracts/:contractId/regenerate-review',
  contractsDevalidate: 'contracts/:contractId/devalidate',
  contractsValidate: 'contracts/:contractId/validate',
  contractsLock: 'contracts/:contractId/lock',
  adminReferentielsCompanies: 'admin/referentiels/companies',
  adminReferentielsSignatories: 'admin/referentiels/signatories',
  adminReferentielsContractualClauses: 'admin/referentiels/contractual-clauses',
  contractsDocumentDownload: (id: number, type: 'contrat' | 'lettre') =>
    `contracts/${id}/document/download?type=${type}`,
  contractsSendToSign: (id: number) => `contracts/${id}/send-to-sign`,
  contractsReturnFromDocusign: (id: number) => `contracts/${id}/return-from-docusign`,
  contractsCancelSignature: (id: number) => `contracts/${id}/cancel-signature`,
};
